import { FCWithChildren } from '@types';
import React from 'react';
import { Modal, ModalBody } from '@components';

type ModalThankYouGuestProps = {
  isOpen: boolean;
  onClose: () => void;
  expiry: string;
};

const ModalVerificationCheckEmail: FCWithChildren<ModalThankYouGuestProps> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal closeModal={onClose} isOpen={isOpen}>
      <ModalBody>
        <div className="mb-2 text-center">
          <h2 style={{ fontSize: '125%' }} className="pb-5">
            Check Email
          </h2>
        </div>
        <div className="mb-5">
          <p>
            Please check your email and follow the confirmation link for steps to complete
            verification.
          </p>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ModalVerificationCheckEmail;
